export default __webpack_public_path__ + "static/media/Light_small.89f065d8.svg";